import { useEffect, useState } from 'react';
import { User } from './types/User';
import Tabs from '../Tabs';
import {
    fetchCampaignsOfUser,
    fetchCampaignRequestsOfUser,
} from '~/services/users';
import CampaignTable from './tables/CampaignTable';
import CampaignRequestTable from './tables/CampaignRequestTable';

interface Props {
    user: User;
}

const MedProfessionalTabs: React.FC<Props> = ({ user }) => {
    const [openTab, setOpenTab] = useState(1);
    const [campaigns, setCampaigns] = useState([]);
    const [campaignRequests, setCampaignRequests] = useState([]);

    const tabs = [
        { name: 'Campaigns', count: 11 },
        { name: 'Campaign Requests', count: 6 },
    ];
    const fetchAndSetCampaignRequest = async () => {
        const campaignRequestResponse = await fetchCampaignRequestsOfUser({
            user_id: user?.id,
        });
        setCampaignRequests(campaignRequestResponse.results);
    };

    const fetchAndSetCampaign = async () => {
        const campaignResponse = await fetchCampaignsOfUser({
            user_id: user?.id,
        });
        setCampaigns(campaignResponse.results);
    };
    useEffect(() => {
        fetchAndSetCampaign();
        fetchAndSetCampaignRequest();
    }, []);

    return (
        <>
            <Tabs tabNames={tabs} openTab={openTab} setOpenTab={setOpenTab}>
                {openTab == 1 && <CampaignTable campaigns={campaigns} />}
                {openTab == 2 && (
                    <CampaignRequestTable campaigns={campaignRequests} />
                )}
            </Tabs>
        </>
    );
};

export default MedProfessionalTabs;
